export default "__VITE_ASSET__DOYPuv8k__"